import {resetSessionInfo} from "./sessionInfo";
import {resetSessionTime} from "./sessionTime";

export const hetch = function(...params) {
    return fetch(...params).then(async (res) => {
        const blob = await res.blob(),
            text = await blob.text();
        if (res.status === 423 || text === 'This session has been expired (possibly due to multiple concurrent logins being attempted as the same user).')
        {
            try {
                resetSessionInfo();
                resetSessionTime();
            } finally {
                window.location.href = '/';
            }
        }
        return {
            ok: res.ok,
            headers: res.headers,
            json: () => Promise.resolve(JSON.parse(text)),
            status: res.status,
            text: () => Promise.resolve(text),
            blob: () => Promise.resolve(blob),
        };
    })
}